var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cduWrapper"}},[_c('div',{attrs:{"id":"cduHeader"}},[_c('header-outer'),_c('header-outer',{ref:"headerOuter"})],1),_c('div',{attrs:{"id":"cduBody"}},[_c('body-outer',{on:{"funckeyPress":_vm.funckeyPressed}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }